/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/named-item.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const NamedItemRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Value: oldRecord.Name,
        ListName: oldRecord.Type,
        Type: null,
        Name: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        Value: newRecord.Name,
        ListName: newRecord.Type,
        Type: null,
        Name: null,
    };
    const enums: any = {
        ListName: AuditEnumValues.NamedItemType,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { NamedItemRecordChangeGrid };
